module.exports = __webpack_public_path__ + "static/media/send-letter-info-img2.9ece9f4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/send-letter-info-img2.png
// module id = 1313
// module chunks = 1